/*
  nw-help-nav — Seitennavigation fürs Hilfecenter, Struktur wie support.neowake.de.

  Wird von zwei Sections benutzt:
    - nw-help-categories (Hub)     : Navigation links, Kategorie-Inhalt rechts
    - nw-help-article   (Artikel)  : Navigation links, Artikel rechts

  Datenquelle ist `assets/nw-help-index.json` (Handle, Titel, Kategorie,
  Subkategorie, Untertitel). Bewusst NICHT aus Liquid gerendert: die Schleife
  `metaobjects.*.values` schneidet bei 50 Einträgen ab und würde von 183
  Artikeln still 133 unterschlagen.

  Optik: Aufbau und Hierarchie sind von der KB übernommen (Navigation links,
  Kategorien mit Pfeil, eingerückte Subkategorien, aktive hervorgehoben).
  Farben und Schrift kommen bewusst NICHT aus HubSpot, sondern aus dem Theme —
  sonst säße ein fremdes Blau/Gelb mitten im Shop.
*/
(function () {
  'use strict';

  var geladen = null;

  function indexLaden(url) {
    if (!geladen) {
      geladen = fetch(url, { credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) { return (d && d.artikel) || []; });
    }
    return geladen;
  }

  /* Kategorien in der Reihenfolge der KB. Was dort nicht steht, wird hinten
     angehängt — so verschwindet eine neue Kategorie nicht stillschweigend. */
  function sortiereKategorien(vorhandene, reihenfolge) {
    var rang = {};
    reihenfolge.forEach(function (k, i) { rang[k.trim().toLowerCase()] = i; });
    return vorhandene.slice().sort(function (a, b) {
      var ra = rang[a.toLowerCase()], rb = rang[b.toLowerCase()];
      if (ra == null && rb == null) return a.localeCompare(b, 'de');
      if (ra == null) return 1;
      if (rb == null) return -1;
      return ra - rb;
    });
  }

  function gruppiere(artikel) {
    var kat = {};
    artikel.forEach(function (a) {
      var k = a.k || '—';
      var s = a.s || '';
      kat[k] = kat[k] || { name: k, subs: {}, anzahl: 0 };
      kat[k].subs[s] = kat[k].subs[s] || [];
      kat[k].subs[s].push(a);
      kat[k].anzahl++;
    });
    Object.keys(kat).forEach(function (k) {
      Object.keys(kat[k].subs).forEach(function (s) {
        kat[k].subs[s].sort(function (x, y) {
          return (x.t || '').localeCompare(y.t || '', 'de');
        });
      });
    });
    return kat;
  }

  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) e.textContent = text;
    return e;
  }

  function baueNav(wurzel, daten, cfg) {
    var ziel = wurzel.querySelector('[data-nw-nav="liste"]');
    if (!ziel) return;
    ziel.textContent = '';

    var kat = daten.gruppen;
    var namen = sortiereKategorien(Object.keys(kat), cfg.reihenfolge);

    namen.forEach(function (name) {
      var g = kat[name];
      var offen = name.toLowerCase() === (cfg.aktiveKategorie || '').toLowerCase();

      var eintrag = el('li', 'nw-hnav__eintrag' + (offen ? ' is-offen' : ''));

      var kopf = el('a', 'nw-hnav__kat');
      kopf.href = cfg.hubUrl + '#' + encodeURIComponent(name);
      kopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
      // Die Seitennavigation bleibt ohne Unterstreichung (`link-faded`:
      // Deckkraft 0.7 -> 1 beim Hover). Die Linie ist der Hinweis „das ist ein
      // Artikel" und gehoert deshalb nur an die Artikel-Links rechts —
      // hier fuehrt sie zu Kategorien und waere nur Rauschen.
      kopf.appendChild(el('span', 'nw-hnav__kat-text link-faded', name));
      kopf.appendChild(el('span', 'nw-hnav__pfeil'));
      eintrag.appendChild(kopf);

      if (offen) {
        var subs = Object.keys(g.subs).filter(Boolean)
          .sort(function (a, b) { return a.localeCompare(b, 'de'); });
        if (subs.length) {
          var ul = el('ul', 'nw-hnav__subs');
          subs.forEach(function (s) {
            var li = el('li');
            var a = el('a', 'nw-hnav__sub link-faded'
              + (s.toLowerCase() === (cfg.aktiveSub || '').toLowerCase() ? ' is-aktiv' : ''));
            a.href = cfg.hubUrl + '#' + encodeURIComponent(name) + '|' + encodeURIComponent(s);
            a.textContent = s;
            li.appendChild(a);
            ul.appendChild(li);
          });
          eintrag.appendChild(ul);
        }
      }

      ziel.appendChild(eintrag);
    });

    wurzel.setAttribute('aria-busy', 'false');
  }

  /* Rechte Spalte des Hubs: Kategorie-Überschrift, dann je Subkategorie die
     Artikel — genau die Gliederung, die die KB dort zeigt. */
  function baueInhalt(wurzel, daten, cfg) {
    var ziel = wurzel.querySelector('[data-nw-nav="inhalt"]');
    if (!ziel) return;
    ziel.textContent = '';

    var g = daten.gruppen[cfg.aktiveKategorie];
    if (!g) { ziel.appendChild(el('p', 'text-subdued', cfg.texte.leer)); return; }

    var h = el('h2', cfg.ueberschriftKlasse, g.name);
    h.className = cfg.ueberschriftKlasse + ' nw-hcont__titel';
    ziel.appendChild(h);

    var subs = Object.keys(g.subs).sort(function (a, b) {
      if (!a) return -1;
      if (!b) return 1;
      return a.localeCompare(b, 'de');
    });

    subs.forEach(function (s) {
      var block = el('section', 'nw-hcont__gruppe');
      if (s) {
        var hs = el('h3', 'h5 nw-hcont__sub');
        hs.textContent = s;
        hs.id = 'sub-' + s.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        block.appendChild(hs);
      }
      var ul = el('ul', 'nw-hcont__liste');
      g.subs[s].forEach(function (a) {
        var li = el('li');
        var link = el('a', 'nw-hcont__link link');
        link.href = cfg.artikelBasis + '/' + a.h;
        link.textContent = a.t;
        li.appendChild(link);
        ul.appendChild(li);
      });
      block.appendChild(ul);
      ziel.appendChild(block);
    });
  }

  /* Liquids `url_encode` schreibt Leerzeichen als `+`, `encodeURIComponent` als
     `%20`. Der Hash kann aus beiden Quellen stammen (Brotkrumen bzw. Navigation),
     deshalb vor dem Dekodieren vereinheitlichen. */
  function hashDekodieren(s) {
    try { return decodeURIComponent(String(s || '').replace(/\+/g, ' ')); }
    catch (e) { return String(s || '').replace(/\+/g, ' '); }
  }

  function ausHash(gruppen, standard) {
    var roh = (window.location.hash || '').replace(/^#/, '');
    if (!roh) return { kategorie: standard, sub: '' };
    var teile = roh.split('|');
    var k = hashDekodieren(teile[0]);
    var s = teile[1] ? hashDekodieren(teile[1]) : '';
    var treffer = Object.keys(gruppen).find(function (n) {
      return n.toLowerCase() === k.toLowerCase();
    });
    return { kategorie: treffer || standard, sub: s };
  }

  window.nwHelpNav = function (optionen) {
    var wurzel = document.getElementById(optionen.wurzelId);
    if (!wurzel) return;

    indexLaden(optionen.indexUrl).then(function (artikel) {
      var daten = { gruppen: gruppiere(artikel) };
      var namen = Object.keys(daten.gruppen);
      if (!namen.length) { wurzel.setAttribute('aria-busy', 'false'); return; }

      var standard = sortiereKategorien(namen, optionen.reihenfolge)[0];

      function zeichne() {
        var cfg = {
          reihenfolge: optionen.reihenfolge,
          hubUrl: optionen.hubUrl,
          artikelBasis: optionen.artikelBasis,
          ueberschriftKlasse: optionen.ueberschriftKlasse || 'h3',
          texte: optionen.texte || { leer: '' },
          aktiveKategorie: optionen.aktiveKategorie,
          aktiveSub: optionen.aktiveSub,
        };
        // Auf dem Hub bestimmt der Hash die Auswahl, auf der Artikelseite der Artikel.
        if (!optionen.aktiveKategorie) {
          var aus = ausHash(daten.gruppen, standard);
          cfg.aktiveKategorie = aus.kategorie;
          cfg.aktiveSub = aus.sub;
        }
        baueNav(wurzel, daten, cfg);
        baueInhalt(wurzel, daten, cfg);
        if (cfg.aktiveSub) {
          var anker = wurzel.querySelector('#sub-' + cfg.aktiveSub.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
          if (anker && window.location.hash) anker.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }

      zeichne();
      if (!optionen.aktiveKategorie) window.addEventListener('hashchange', zeichne);
    }).catch(function () {
      wurzel.setAttribute('aria-busy', 'false');
      var ziel = wurzel.querySelector('[data-nw-nav="inhalt"]') || wurzel;
      ziel.textContent = '';
      ziel.appendChild(el('p', 'text-subdued', (optionen.texte || {}).leer || ''));
    });
  };
})();
